import { Carousel } from 'antd'
import Image from 'next/image'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import PhoneCarousel from './PhoneCarousel'

const Tutorial = ({ step, onClose, imgHorizontal }) => {
  const imgToggle = useRef()
  const [currentSlide, setcurrentSlide] = useState(0)
  const [carousel, setCarousel] = useState(step?.[0]?.img || '')
  const [autoplay, setAutoplay] = useState(true)

  const Handler = index => {
    setCarousel(step[index].img)
    setcurrentSlide(index)
  }

  return (
    <div className='fixed z-[99999] w-full h-[100vh] pb-[20px] bg-white top-0 overflow-auto flex flex-col items-center'>
      <div className='w-full min-h-[50px] px-[15px] flex items-center justify-end'>
        <Image
          src='/images/android/setup/close.svg'
          width={16}
          height={16}
          alt='close'
          className='cursor-pointer'
          onClick={onClose}
        />
      </div>
      <PhoneCarousel
        imgHorizontal={imgHorizontal}
        step={step}
        currentSlide={currentSlide}
        setcurrentSlide={setcurrentSlide}
        carousel={carousel}
        setCarousel={setCarousel}
      />
      <div className='w-full px-[20px] mt-[30px] smj:pb-[90px]'>
        {step.map((item, i) => (
          <div
            key={i}
            className={`${i != 0 ? 'mt-[9px] Dsm:mt-[8px]' : ''} flex cursor-pointer`}
            onClick={() => Handler(i)}
          >
            <div
              className={`${currentSlide == i ? 'text-[#FFF] bg-[#2A99FF]' : ''
                } text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]`}
            >
              {i + 1}.
            </div>
            &ensp;{item.title}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Tutorial
